import { totangoTheme } from '@totango-app-team/ui-shared-components';

export default totangoTheme;
